import React, {useState} from 'react'

function AddRemark(props) {
    
    const [remarkData, setRemarkData]= useState('')

    let data = remarkData
    //    props.update(data)

    const handleSave = ()=> {
        props.CommentRemarkDataSave(data)
        setRemarkData("")
    }

    return (
        <div className='flex-col'>        

                <textarea 
                type="text" 
                className="form-group text-area remark-add"
                value= {remarkData}
                name="remarks" 
                 onChange={(e)=>{
          
                  e.preventDefault();
                  setRemarkData(e.target.value)
          } }
            autoComplete="off"
                />
            <button disabled={remarkData===''} onClick={handleSave} className='btn btn-primary btn-col'>Save</button>
        </div>
    )
}

export default AddRemark
